import { Component } from '@angular/core';

/** Coquille : barre de titre + contenu accès logiciel caisse. */
@Component({
  selector: 'app-acces-logiciel-caisse-shell',
  template: '<app-title-section></app-title-section><router-outlet></router-outlet>',
})
export class AccesLogicielCaisseShellComponent {}
